import { initAwsRum } from 'odc-shared/utils/initAwsRum';
import ReactDOM from 'react-dom/client';

import App from './App';
import { awsRumConfig } from './config/env.config';

if (awsRumConfig.identityPoolId && awsRumConfig.applicationId) {
  initAwsRum({
    identityPoolId: awsRumConfig.identityPoolId,
    applicationId: awsRumConfig.applicationId,
  });
}
async function main() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<App />);
}
main();